import { addCalendarDays, businessDate, calendarDaysBetween } from './business-date';

/*
 * The correction window (UC40-06, UC50-06, UC51-03; CF-13, CF-14): a movement may
 * be corrected for `windowDays` calendar days after the Europe/Chisinau date its
 * report was accepted on, that date being day 0, whatever the hour of either
 * moment (docs/shape-ops-correction-window.md D1).
 */

/** The last date a correction is admitted, `YYYY-MM-DD`. */
export function correctionDeadline(acceptedAt: Date, windowDays: number): string {
  return addCalendarDays(businessDate(acceptedAt), windowDays);
}

/** Whether a correction of a report accepted at `acceptedAt` is admitted at `now`. */
export function withinCorrectionWindow(
  acceptedAt: Date,
  windowDays: number,
  now: Date = new Date(),
): boolean {
  return calendarDaysBetween(acceptedAt, now) <= windowDays;
}
